/**
 * 作品末端のタブに表示する`TagButton`の表示数を算出する関数
 * - 1タブあたりの表示数(以下a)は20の倍数にすること
 * - エピソード数 ÷ 20a < 6 となる20aが1タブあたりの表示数
 */
export const splitRangeLength = (totalItemLength: number) => {
  let onePageTabNumber = 1;

  const ITEM_NUM_PER_TAB = 20;
  const MAX_TAB_COUNT = 6;

  while (totalItemLength / (ITEM_NUM_PER_TAB * onePageTabNumber) > MAX_TAB_COUNT) {
    onePageTabNumber++;
  }

  return ITEM_NUM_PER_TAB * onePageTabNumber;
};
